import React from 'react';

function Footer() {
    return (
        <>
            <section className="cash-footer-area">
                
                <div className="row social-bar">
                    <div className="social container">
                        <div className="row d-flex align-items-center">
                            <div className="col-md-6 col-lg-5 mb-md-0"></div>
                            <div className="col-md-6 col-lg-7 text-right">
                                <a className="m-2 fa-lg fb-ic ml-0" href="https://www.facebook.com/CashConvertersNZ" rel="noopener noreferrer" target="_blank" title="Facebook">
                                    <svg aria-hidden="true" focusable={false} data-prefix="fab" data-icon="facebook-square" className="svg-inline--fa fa-facebook-square fa-w-14 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" color="white">
                                        <path fill="currentColor" d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"></path>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container mt-5 mb-2">
                    <div className="row mt-3">
                        <div className="col-md-3 col-lg-4 col-xl-3 mb-4">
                            <h6 className="text-uppercase font-weight-bold">Cash Converters</h6>
                            <hr className="blue mb-4 mt-0 d-inline-block mx-auto"></hr>
                            <p>
                                <a className="docs-creator" href="https://www.cashconverters.co.nz/" rel="noopener noreferrer"
                                    target="_blank">Cash Converters New Zealand</a></p>
                        </div>
                        <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
                            <h6 className="text-uppercase font-weight-bold">Quick links</h6>
                            <hr className="blue mb-4 mt-0 d-inline-block mx-auto"></hr>
                            <p className="mb-3"><a className="d-block full-width mb-3 docs-creator"
                                    href="https://www.cashconverters.co.nz/pawns/" rel="noopener noreferrer" target="_blank">Pawn With
                                    Us</a></p>
                            <p className="mb-3"><a className="d-block full-width mb-3 docs-creator"
                                    href="https://www.cashconverters.co.nz/sell/" rel="noopener noreferrer" target="_blank">Sell To
                                    Us</a></p>
                            <p className="mb-3"><a className="d-block full-width mb-3 docs-creator" href="https://www.cashconverters.co.nz/buy/"
                                    rel="noopener noreferrer" target="_blank">Buy From Us</a></p>
                            <p className="mb-3"><a className="d-block full-width mb-3 docs-creator"
                                    href="https://www.cashconverters.co.nz/stores/" rel="noopener noreferrer" target="_blank">Our
                                    Stores</a></p>
                            <p className="mb-3"><a className="d-block full-width mb-3 docs-creator"
                                    href="https://www.cashconverters.co.nz/about-us/" rel="noopener noreferrer" target="_blank">About
                                    Us</a></p>
                            <p className="mb-3"><a className="d-block full-width mb-3 docs-creator"
                                    href="https://www.cashconverters.co.nz/join-us/" rel="noopener noreferrer" target="_blank">Join
                                    Us</a></p>
                            <p className="mb-3"><a className="d-block full-width mb-3 docs-creator"
                                    href="https://www.cashconverters.co.nz/contact-us/" rel="noopener noreferrer"
                                    target="_blank">Contact Us</a></p>
                        </div>
                        <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
                            <h6 className="text-uppercase font-weight-bold">Useful links</h6>
                            <hr className="blue mb-4 mt-0 d-inline-block mx-auto"></hr>
                            <p className="mb-3"><a className="d-block full-width mb-3 docs-creator"
                                    href="https://www.cashconverters.co.nz/customer-support/" rel="noopener noreferrer"
                                    target="_blank">Customer Support</a> </p>
                            <p className="mb-3"><a className="d-block full-width mb-3 docs-creator"
                                    href="https://www.cashconverters.co.nz/franchise-opportunities/" rel="noopener noreferrer"
                                    target="_blank">Franchising</a></p>
                            <p className="mb-3"><a className="d-block full-width mb-3 docs-creator"
                                    href="https://www.cashconverters.co.nz/cashpass-terms-and-conditions/" rel="noopener noreferrer"
                                    target="_blank">CashPass Terms</a></p>
                            <p className="mb-3"><a className="d-block full-width mb-3 docs-creator"
                                    href="https://www.cashconverters.co.nz/terms-and-conditions/" rel="noopener noreferrer"
                                    target="_blank">Website Terms</a></p>
                        </div>
                        <div className="col-md-4 col-lg-3 col-xl-3">
                            <h6 className="text-uppercase font-weight-bold">Contact</h6>
                            <hr className="blue mb-4 mt-0 d-inline-block mx-auto"></hr>
                            <p className="mb-3">Online Live Chat</p>
                            <p className="mb-3"><a className="d-block full-width mb-3 docs-creator"
                                    href="https://www.cashconverters.co.nz/contact-us/" rel="noopener noreferrer"
                                    target="_blank">Enquiries@cashconverters.co.nz</a></p>
                            <p className="mb-3"><a className="d-block full-width mb-3 docs-creator"
                                    href="https://www.cashconverters.co.nz/stores/" rel="noopener noreferrer" target="_blank">Your Local
                                    Store</a></p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="footer-copyright d-flex align-items-center justify-content-center">
                            <div className="copyright-text">
                                <p>© 2024 Copyright: Cash Converters Holdings (NZ) Ltd NZBN: 9429050975655</p>
                            </div>
                        </div>
                    </div>
                </div>
                
            </section>
        </>
    );
}

export default Footer;
